// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3iBJ6","image":"App_image__3fTdm"};